export const strings = {
    // Card and Titles
    investmentFunds: 'Investment funds',
    selectFunds: 'Select funds',
    AMC: 'AMC',
    allocation: 'Allocation',
    percentageSymbol: '%',
    errorMessage: 'The total fund allocation must equal 100%',
    allocationOverlimitMessage: 'Your current allocation is over 100%',
};
